import { useRef } from 'react';
import constate from 'constate';
import { SbPosition } from 'components/app/editor/_mediator/editor-controls.slice';

const useSbProvider = () => {
  const sbListenClip = useRef<({ clipId: CellClip } & SbPosition) | null>(null);
  const sbListenSkipDamping = useRef(false);
  const sbListenPanZoom = useRef(false);
  return { sbListenClip, sbListenSkipDamping, sbListenPanZoom };
};

export const [SbProvider, useSbContext] = constate(useSbProvider);
